import { gql } from '@apollo/client'

export const FlexibleContentFragment = gql`
  fragment FlexibleContentFragment on Page {
    template {
      ... on DefaultTemplate {
        flexibleContent {
          fieldGroupName
          flexibleContentFields {
            ...FlexibleContentLayoutFields
          }
        }
      }
      # Note: Template_FullWidth does not have flexibleContent ACF field group assigned in WordPress.
      # If Full Width pages need flexible content, configure ACF to include that template, then
      # regenerate possibleTypes.json and add the fragment back here.
    }
  }

  fragment FlexibleContentLayoutFields on FlexibleContentFlexibleContentFields_Layout {
    ... on FlexibleContentFlexibleContentFieldsAlternatingTextAndImageLayout {
      fieldGroupName
      alternatingTextContent
      alternatingSubheading
      alternatingHeading
      alternatingContentImageFullWidth
      alternatingIcon {
        node {
          altText
          sourceUrl
        }
      }
      imageRightOrLeft
      alternatingImage {
        node {
          altText
          sourceUrl
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsSliderLayout {
      eyebrowText
      fieldGroupName
      sliderContent
      sliderTitle
      card {
        cardContent
        cardIcon {
          node {
            altText
            sourceUrl
          }
        }
        cardTitle
      }
    }
    ... on FlexibleContentFlexibleContentFieldsServicesRepeaterLayout {
      fieldGroupName
      heading
      subHeading
      darkBackground
      hideDescription
      services {
        nodes {
          ... on Service {
            id
            slug
            serviceListingFields {
              serviceListingDescription
              serviceListingImage {
                node {
                  altText
                  sourceUrl
                }
              }
              serviceListingWhiteImage {
                node {
                  altText
                  sourceUrl
                }
              }
              serviceListingName
              servicePageLink {
                url
              }
            }
          }
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsJobsfeedLayout {
      fieldGroupName
      jobs {
        jobIcon {
          node {
            altText
            sourceUrl
          }
        }
        jobTitle
        jobUrl
      }
    }
    ... on FlexibleContentFlexibleContentFieldsFeaturedCaseStudiesBlockLayout {
      fieldGroupName
      featuredCaseStudies {
        nodes {
          ... on CaseStudy {
            title
            uri
            caseStudyFields {
              casestudyServices {
                nodes {
                  ... on CaseStudyService {
                    id
                    name
                  }
                }
              }
              heroImage {
                node {
                  altText
                  sourceUrl
                }
              }
              cardImage {
                node {
                  altText
                  sourceUrl
                }
              }
              title
            }
          }
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsActionableInsightsBlockLayout {
      fieldGroupName
      headline
      insightOneContent
      insightOneHeadline
      insightOneLogo {
        node {
          altText
          sourceUrl
        }
      }
      insightThreeContent
      insightThreeHeadline
      insightTwoContent
      insightTwoHeadline
      insightThreeLogo {
        node {
          altText
          sourceUrl
        }
      }
      insightTwoLogo {
        node {
          altText
          sourceUrl
        }
      }
      insightOneLink {
        target
        title
        url
      }
      insightTwoLink {
        target
        title
        url
      }
      insightThreeLink {
        target
        title
        url
      }
    }
    # LeaderProfile: uncomment ONLY after the "Leader Profile" layout exists in the
    # flexibleContent ACF field group. GraphQL rejects the whole query — breaking every
    # page, not just leader pages — while this type is absent from the schema. After
    # adding it in ACF, regenerate possibleTypes.json and uncomment.
    # ... on FlexibleContentFlexibleContentFieldsLeaderProfileLayout {
    #   fieldGroupName
    #   eyebrow
    #   leaderName
    #   intro
    #   bioHeading
    #   bio
    #   headshot {
    #     node {
    #       altText
    #       sourceUrl(size: MEDIUM_LARGE)
    #     }
    #   }
    #   backgroundImage {
    #     node {
    #       altText
    #       sourceUrl
    #     }
    #   }
    #   connectLink {
    #     url
    #     title
    #     target
    #   }
    #   socialLinks {
    #     fieldGroupName
    #     platform
    #     url
    #   }
    # }
    ... on FlexibleContentFlexibleContentFieldsTeamPhotoFeedLayout {
      fieldGroupName
      teamFeedDescription
      teamFeedSubheading
      teamFeedheading
      teamHeadshots {
        fieldGroupName
        headshot {
          node {
            sourceUrl(size: MEDIUM_LARGE)
          }
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsContentWithPhotoFeedLayout {
      fieldGroupName
      contentPhotoSubheading
      choiceTextOrImageheading
      contentPhotoheading
      parallaxContinuousScroll
      headingInsideBox
      logoHeading {
        node {
          altText
          sourceUrl
        }
      }
      contentPhotoDescription
      contentPhotoLinkOne {
        target
        title
        url
      }
      contentPhotoLinkTwo {
        target
        title
        url
      }
      photoFeed {
        fieldGroupName
        photo {
          node {
            sourceUrl
          }
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsContentWithImagesLayout {
      fieldGroupName
      contentImagesHeading
      contentImagesSubheading
      contentImagesDescription
      putImagesInSlider
      slidesPerView
      spaceBetween
      images {
        contentLink {
          target
          title
          url
        }
        image {
          node {
            altText
            sourceUrl
          }
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsStandardContentDarkBackgroundLayout {
      description
      fieldGroupName
      heading
      subheading
    }
    ... on FlexibleContentFlexibleContentFieldsContentBlockLayout {
      description
      fieldGroupName
      heading
      subheading
    }
    ... on FlexibleContentFlexibleContentFieldsTwoColumnContentLayout {
      columnOneContent
      columnTwoContent
      fieldGroupName
    }
    ... on FlexibleContentFlexibleContentFieldsIndustryHighlightsLayout {
      fieldGroupName
      industryHighlights {
        fieldGroupName
        industryDescription
        industryHeadline
        industryIcon {
          node {
            altText
            sourceUrl
          }
        }
      }
    }
    ... on FlexibleContentFlexibleContentFieldsInstagramfeedLayout {
      fieldGroupName
    }
    ... on FlexibleContentFlexibleContentFieldsBrandBlockLayout {
      brandFiveDescription
      brandFiveHeadline
      brandFiveLogo {
        node {
          altText
          sourceUrl
        }
      }
      brandFourDescription
      brandFourHeadline
      brandFourLogo {
        node {
          altText
          sourceUrl
        }
      }
      brandOneDescription
      brandOneHeadline
      brandOneLogo {
        node {
          altText
          sourceUrl
        }
      }
      brandSixDescription
      brandSixHeadline
      brandSixLogo {
        node {
          altText
          sourceUrl
        }
      }
      brandThreeDescription
      brandThreeHeadline
      brandThreeLogo {
        node {
          altText
          sourceUrl
        }
      }
      brandTwoDescription
      brandTwoHeadline
      brandTwoLogo {
        node {
          altText
          sourceUrl
        }
      }
      description
      fieldGroupName
      heading
      subheading
    }
    ... on FlexibleContentFlexibleContentFieldsVideoCarouselLayout {
      fieldGroupName
      eyebrowText
      header
      description
      videos {
        videoUrl
        videoThumbnail {
          node {
            altText
            sourceUrl
          }
        }
      }
    }
  }
`
